import request from '@/utils/request'

/**
 * @description 获取视频商品科目信息
 * @param data
 * @returns {*}
 */
export function getVideoGoodsSubject(data) {
  return request.post('/phalapi/public/?service=App.Video.GetVideoGoodsSubject', data)
}

/**
 * @description 开启/关闭做题
 * @param data
 * @returns {*}
 */
export function setVersionQueState(data) {
  return request.post('/phalapi/public/?service=App.Video.SetVersionQueState', data)
}

/**
 * @description 版本管理信息
 * @param data
 * @returns {*}
 */
export function getVideoVersions(data) {
  return request.post('/phalapi/public/?service=App.Shop.GetVideoVersions', data)
}

/**
 * @description 添加版本
 * @param data
 * @returns {*}
 */
export function addVideoVersion(data) {
  return request.post('/phalapi/public/?service=App.Shop.AddVideoVersion', data)
}

/**
 * @description 修改版本
 * @param data
 * @returns {*}
 */
export function editVerion(data) {
  return request.post('/phalapi/public/?service=App.Shop.EditVerion', data)
}

/**
 * @description 删除版本
 * @param data
 * @returns {*}
 */
export function delVideoVersion(data) {
  return request.post('/phalapi/public/?service=App.Shop.DelVideoVersion', data)
}

/**
 * @description 发布版本
 * @param data
 * @returns {*}
 */
export function publishVideo(data) {
  return request.post('/phalapi/public/?service=App.Shop.PublishVideo', data)
}

/**
 * @description 获取视频商品列表
 * @param data
 * @returns {*}
 */
export function videoGoodsList(data) {
  return request.post('/phalapi/public/?service=Shop.Selfvideo.VideoGoodsList', data)
}

/**
 * @description 获取商品课程列表
 * @param data
 * @returns {*}
 */
export function classList(data) {
  return request.post('/phalapi/public/?service=Shop.Selfvideo.ClassList', data)
}

/**
 * @description 复制课程
 * @param data
 * @returns {*}
 */
export function copyClass(data) {
  return request.post('/phalapi/public/?service=Shop.Selfvideo.CopyClass', data)
}

/**
 * @description 设置视频版本科目信息
 * @param data
 * @returns {*}
 */
export function setVideoGoodsVersionSubject(data) {
  return request.post('/phalapi/public/?service=App.Video.SetVideoGoodsVersionSubject', data)
}

/**
 * @description 获取科目商品列表
 * @param data
 * @returns {*}
 */
export function getSubjectVideoList(data) {
  return request.post('/phalapi/public/?service=App.Video.GetSubjectVideoList', data)
}

/**
 * @description 视频排序
 * @param data
 * @returns {*}
 */
export function setVideoSort(data) {
  return request.post('/phalapi/public/?service=App.Video.SetVideoSort', data)
}

/**
 * @description 批量删除
 * @param data
 * @returns {*}
 */
export function videoBacthDel(data) {
  return request.post('/phalapi/public/?service=Shop.Selfvideo.VideoBacthDel', data)
}

/**
 * @description 设置视频收费
 * @param data
 * @returns {*}
 */
export function setVideoIsFree(data) {
  return request.post('/phalapi/public/?service=App.Video.SetVideoIsFree', data)
}

/**
 * @description 上传讲义
 * @param data
 * @returns {*}
 */
export function uplodeVideoTeach(data, onUploadCb) {
  return request.post('/phalapi/public/?service=Shop.Selfvideo.UplodeVideoTeach', data, { onUploadProgress: onUploadCb })
}

/**
 * @description 上传ppt
 * @param data
 * @returns {*}
 */
export function uplodeVideoPpt(data, onUploadCb) {
  return request.post('/phalapi/public/?service=Shop.Selfvideo.uplodeVideoPpt', data, { onUploadProgress: onUploadCb })
}

/**
 * @description 删除讲义
 * @param data
 * @returns {*}
 */
export function deleteVideoTeach(data) {
  return request.post('/phalapi/public/?service=Shop.Selfvideo.DeleteVideoTeach', data)
}

/**
 * @description 获取视频信息
 * @param data
 * @returns {*}
 */
export function getInfo(data) {
  return request.post('/phalapi/public/?service=App.Video.GetInfo', data)
}

/**
 * @description 七牛上传视频信息
 * @param data
 * @returns {*}
 */
export function getQiniuConfig(data) {
  return request.post('/phalapi/public/?service=App.Common.GetQiniuConfig', data)
}

/**
 * @description 七牛获取视频地址
 * @param data
 * @returns {*}
 */
export function getQiniuVideoUrl(data) {
  return request.post('/phalapi/public/?service=App.Common.GetQiniuVideoUrl', data)
}

/**
 * @description 设置视频试听时间
 * @param data
 * @returns {*}
 */
export function setVideoFreeTime(data) {
  return request.post('/phalapi/public/?service=App.Video.SetVideoFreeTime', data)
}

/**
 * @description 批量设置视频试听时间
 * @param data
 * @returns {*}
 */
export function multiSetVideoFreeTime(data) {
  return request.post('/phalapi/public/?service=App.Video.multiSetVideoFreeTime', data)
}

/**
 * @description 设置整个视频试听时间
 * @param data
 * @returns {*}
 */
export function setVideoFreeTimeByGood(data) {
  return request.post('/phalapi/public/?service=App.Video.SetVideoFreeTimeByGood', data)
}
// 新接口
/**
 * @description 生成字幕
 * @param data
 * @returns {*}
 */
export function generateSubtitle(data) {
  return request.post('/phalapi/public/?service=App.Video.generateSubtitle', data)
}
/**
 * @description 获得字幕列表
 * @param data
 * @returns {*}
 */
export function getSubtitleList(data) {
  return request.post('/phalapi/public/?service=App.Video.getSubtitleList', data)
}
/**
 * @description 批量标记字幕
 * @param data
 * @returns {*}
 */
export function doBatchMarkSubtitle(data) {
  return request.post('/phalapi/public/?service=App.Video.doBatchMarkSubtitle', data)
}
/**
 * @description 单个标记字幕
 * @param data
 * @returns {*}
 */
export function doMarkSubtitle(data) {
  return request.post('/phalapi/public/?service=App.Video.doMarkSubtitle', data)
}
/**
 * @description 获得视频字幕信息
 * @param data
 * @returns {*}
 */
export function getSubtitleInfo(data) {
  return request.post('/phalapi/public/?service=App.Video.getSubtitleInfo', data)
}
/**
 * @description 导出标记列表
 * @param data
 * @returns {*}
 */
export function exportSubtitleMarkList(data) {
  return request.post('/phalapi/public/?service=App.Video.exportSubtitleMarkList', data)
}
/**
 * @description 删除标记
 * @param data
 * @returns {*}
 */
export function delSubtitleMark(data) {
  return request.post('/phalapi/public/?service=App.Video.delSubtitleMark', data)
}
/**
 * @description 编辑标记
 * @param data
 * @returns {*}
 */
export function editSubtitleMark(data) {
  return request.post('/phalapi/public/?service=App.Video.editSubtitleMark', data)
}
/**
 * @description 切换视频字幕状态
 * @param data
 * @returns {*}
 */
export function changeVideoSubtitleState(data) {
  return request.post('/phalapi/public/?service=App.Video.changeVideoSubtitleState', data)
}
/**
 * @description 导出字幕标记列表（获取key值）
 * @param data
 * @returns {*}
 */
export function submitSubtitleMarkTask(data) {
  return request.post('/phalapi/public/?service=App.Video.submitSubtitleMarkTask', data)
}
/**
 * @description 导出字幕标记列表
 * @returns {*}
 */
export function checkSubtitleMarkTask(data) {
  return request.post('/phalapi/public/?service=App.Video.checkSubtitleMarkTask', data)
}
/**
 * @description 将视频设为更新中
 * @returns {*}
 */
export function setVideoUpdatingApi(data) {
  return request.post('/phalapi/public/?service=App.Video.SetVideoUpdating', data)
}
/**
 * @description 获取视频hash关联的视频信息
 * @returns {*}
 */
export function getVideoInfoByHashApi(data) {
  return request.post('/phalapi/public/?service=App.Video.GetVideoInfoByHash', data)
}
/**
 * @description 获取目录树状结构
 * @returns {*}
 */
export function getBookDirTrees(data) {
  return request.post('/phalapi/public/?service=Tiku.Book.GetBookDirTrees', data)
}
/**
 * @description 获取视频的可用书籍列表
 * @returns {*}
 */
export function getBooksByGoodsid(data) {
  return request.post('/phalapi/public/?service=App.Video.getBooksByGoodsid', data)
}
/**
 * @description 保存关联
 * @returns {*}
 */
export function saveBookClassRelation(data) {
  return request.post('/phalapi/public/?service=App.Video.saveBookClassRelation', data)
}
/**
 * @description 设置视频关联目录
 * @returns {*}
 */
export function setVideoDirs(data) {
  return request.post('/phalapi/public/?service=App.Video.SetVideoDirs', data)
}
/**
 * @description 获取视频勘误信息
 * @param {*} data
 * @returns
 */
export function getVideoCorrectInfo(data) {
  return request.post('/phalapi/public/?service=App.Video.GetVideoBackstageCorrection', data)
}

/**
 * @description 保存视频勘误信息
 * @param {*} data
 * @returns
 */
export function saveVideoCorrectInfo(data) {
  if (data.id) {
    return request.post('/phalapi/public/?service=App.Video.EditVideoBackstageCorrection', data)
  }
  return request.post('/phalapi/public/?service=App.Video.AddVideoBackstageCorrection', data)
}

/**
 * @description 删除视频勘误信息
 * @param {*} data
 * @returns
 */
export function delVideoCorrectInfo(data) {
  return request.post('/phalapi/public/?service=App.Video.DelVideoBackstageCorrection', data)
}

/**
 * @description 改变视频勘误状态
 * @param {*} data
 * @returns
 */
export function changeVideoCorrectState(data) {
  return request.post('/phalapi/public/?service=App.Video.ChangeVideoBackstageCorrectionState', data)
}

/**
 * @description 创建视频勘误导出任务
 * @param {*} data
 * @returns
 */
export function createCorrectExportTask(data) {
  return request.post('/phalapi/public/?service=App.Video.CreateBackstageCorrectionExportTask', data)
}

/**
 * @description 检查视频勘误导出任务状态
 * @param {*} data
 * @returns
 */
export function checkCorrectExportTask(data) {
  return request.post('/phalapi/public/?service=App.Video.CheckBackstageCorrectionExportTask', data)
}

/**
 * @description 添加科目
 * @param data
 * @returns {*}
 */
export function addSubject(data) {
  return request.post('/phalapi/public/?service=App.VideoSubject.AddSubject', data)
}

/**
 * @description 批量替换讲义
 * @param data
 * @returns
 */
export function multiReplaceTeachContent(data) {
  return request.post('/phalapi/public/?service=App.Video.multiReplaceTeachContent', data)
}

/**
 * 获取视频字幕
 * @param {Object} data
 * @returns {Promise}
 */
export function getVideoSubtitle(data) {
  return request.post('/phalapi/public/?service=App.VideoSubtitle.GetVideoSubtitle', data)
}

/**
 * 更新视频字幕
 * @param {Object} data
 * @returns {Promise}
 */
export function updateVideoSubtitle(data) {
  return request.post('/phalapi/public/?service=App.VideoSubtitle.UpdateVideoSubtitle', data)
}
